
import { useRef } from "react";
import { ActionHandlerProvider } from "../../../Components/ActionHandlerContext";
import DynamicMaster from "../../../Components/DynamicMaster/DynamicMaster";
import { FormInstance } from "antd";
import { deleteRecordById } from "../../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../../Axios/Axios";

export default function ProductInfo() {
  const formRef = useRef<FormInstance>(null);
  const reportActionHandler = {
    checkIfValidationOK: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay

      return true;
    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 387 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    CheckReportActionFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("CheckReportActionFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay

      return true;
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    // DynamicMasterRowDelete: async (type: string, record: any) => {

    //   try {

    //     let response = await API.post(deleteRecordById, {
    //       Id: record.Key,
    //     });

    //     if (response.data) {
    //       console.log("Deleted successfully.");
    //       await formRef.current!.reloadDashboard();
    //     } else {
    //       console.error("Failed to delete");
    //     }
    //   } catch (error) {
    //     console.error(`Failed to perform`, error);
    //     resolve(false);
    //   } finally {
    //     console.error("Finally block");
    //   }

    // }
  };

  const interfaceActionHandler = {
    handleSubmit: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleSubmit run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay


    },
    handleEndFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleEndFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay

    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 409 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };

  const interfaceFieldActionHandler = {
    SetStateSingleValue: async (form: any) => {
      let formData = form.getFieldsValue();
      console.log(formData);

    },
  };

  return (
    <ActionHandlerProvider
      rowActionHandler={rowActionHandler}
      reportActionHandler={reportActionHandler}
      interfaceActionHandler={interfaceActionHandler}
      interfaceFieldActionHandler={interfaceFieldActionHandler}
    >
      <DynamicMaster
        InterfaceName={"Product Info Master"}
        DashboardName={"Product Info Dashboard"}
        ref={formRef}
      />
    </ActionHandlerProvider>
  );
}
